export const getCurrentPricelist = (store: Store) => store.pricelists.currentPricelist;
